import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import type { ActionRow } from "../types";
import {
  Card,
  CardHeader,
  Dot,
  Empty,
  priorityDot,
  relativeDueLabel,
  SkeletonRow,
  ViewAllLink,
} from "./_shared";

type Props = {
  actions: ActionRow[];
  isLoading?: boolean;
};

export function MyActionsWidget({ actions, isLoading }: Props) {
  return (
    <Card>
      <CardHeader
        icon={
          <Zap
            className="h-4 w-4 text-[hsl(35,90%,35%)]"
            strokeWidth={1.5}
          />
        }
        title="My Actions"
        count={actions.length}
        action={<ViewAllLink href="/actions?assignedToMe=true" />}
      />
      {isLoading ? (
        <div>
          {[0, 1, 2, 3, 4].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : actions.length === 0 ? (
        <Empty
          icon={
            <Zap
              className="h-8 w-8 text-muted-foreground opacity-40"
              strokeWidth={1.5}
            />
          }
          text="No open actions — all clear."
          variant="success"
        />
      ) : (
        <ul className="divide-y" style={{ borderColor: "hsl(210,30%,92%)" }}>
          {actions.slice(0, 5).map((a) => {
            const due = relativeDueLabel(a.dueDate);
            return (
              <li key={a.id}>
                <Link
                  to={`/actions/${a.id}`}
                  className="flex items-center gap-2 py-2 hover:bg-[hsl(210,50%,98%)]"
                >
                  <Dot color={priorityDot(a.priority)} />
                  <span className="truncate text-[13px] font-medium text-foreground">
                    {a.title}
                  </span>
                  <span className="ml-auto flex shrink-0 items-center gap-1.5 text-[11px]">
                    {due.pill && (
                      <span
                        className="rounded-full px-1.5 py-0.5 text-[10px] font-semibold"
                        style={{
                          background: "hsl(0,70%,94%)",
                          color: "hsl(0,70%,40%)",
                        }}
                      >
                        {due.pill}
                      </span>
                    )}
                    <span style={{ color: due.color }}>{due.text}</span>
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
